<flx-heading type="page" size="medium">Installation Summary</flx-heading>

<ng-container>
	<flx-heading size="small" color="secondary">Installation Details</flx-heading>
	<flx-key-value-list [data$]="installationDetails$" align="left" width="110px"></flx-key-value-list>

	<flx-heading size="small" color="secondary">Customer</flx-heading>
	<flx-key-value-list [data$]="clientDetails$" align="left" width="110px"></flx-key-value-list>
</ng-container>
